import { type FunctionalComponent, h } from '@stencil/core';
import { bannerInteractionHandler } from './simple-banner-helpers';
import { setChatVisibilitySessionStorageValue } from '../../conversational-search-logic/storage-manager/storage-manager-helpers';
import type { labelProviderInterface } from '../../../../LabelProviderInterface';

export const ConversationalSearchBannerSimple: FunctionalComponent<{
  labelProvider: labelProviderInterface;
  country?: string;
  language?: string;
  callback: () => void;
}> = (props) => {
    const onClickHandler = () => {
        setChatVisibilitySessionStorageValue(); // Set open chat for Guided Search case
        bannerInteractionHandler(
          props.country,
          props.language,
          props.callback,
        );
    };

    return (
      <div class="conversational-search-simple-banner">
        <strong class="conversational-search-simple-banner__subtitle">
          {props.labelProvider(
            'conversational.search.banner.simple.content',
            'Locate products faster than ever with our AI-powered search tool.',
          )}
        </strong>
        <qds-button
          importance="emphasized"
          onClick={() => onClickHandler()}
          text={props.labelProvider(
            'conversational.search.banner.cta',
            'Try it out',
          )}
        />
      </div>
    );
};
